import { CssBaseline, ThemeProvider as MUIThemeProvider } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { HOST } from '~/constants'
import { AppRoutes } from '~/routes'

import 'moment/locale/fr'

import { AuthLoader } from './lib/auth'
import { queryConfig } from './lib/react-query'
import createMuiThemeFromTokens from './styles/createMuiThemeFromTokens'
import { GlobalStyle } from './styles/global'

import ReactGA from '~/lib/analytics'

export function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      })
  )

  const { theme } = createMuiThemeFromTokens()

  ReactGA.initialize([
    {
      trackingId: 'G-B29Q2D98RR',
      gtagOptions: {
        environment: HOST,
      },
    },
  ])

  return (
    <BrowserRouter>
      <MUIThemeProvider theme={theme}>
        <GlobalStyle />
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <AuthLoader
            renderLoading={() => {
              return <></>
            }}
          >
            <AppRoutes />
          </AuthLoader>
        </QueryClientProvider>
      </MUIThemeProvider>
    </BrowserRouter>
  )
}
